import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  salas:[],
};
export const mutations = {
  FILL_SALAS({ context }, salas) {
    let lista_salas = [];
    if (salas) {
      Object.entries(salas).forEach(([key, val]) => lista_salas.push(val));
      return (state.salas = lista_salas);
    }
  }
};
export const actions = {
    GET_SALAS({ commit }, data) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING", true);
          ApiService.get(data)
            .then(response => {
              commit("SET_LOADING", false);
              commit("FILL_SALAS", response.data.data.salas);
              resolve(response);
            })
            .catch(error => {
              commit("SET_LOADING", false);
              reject(error);
            });
        });
      },
};

export const getters = {
  listSalas: state => state.salas,
};
